import request from '@/utils/request'

/**
 * 概览指标（8 个 KPI 卡片，最新月份）
 * @returns {Promise}
 */
export function getProcurementOverview() {
  return request({
    url: '/eiip-ai/procurement/overview',
    method: 'get'
  })
}

/**
 * 单一来源依赖风险明细（返回最新统计月份的数据）
 * @returns {Promise}
 */
export function getSingleSourceRisk() {
  return request({
    url: '/eiip-ai/procurement/single-source-risk',
    method: 'get'
  })
}

/**
 * 品类采购占比（最新月份）
 * @returns {Promise}
 */
export function getCategoryProcurement() {
  return request({
    url: '/eiip-ai/procurement/category-procurement',
    method: 'get'
  })
}

/**
 * 近 6 个月采购额趋势
 * @returns {Promise}
 */
export function getProcurementTrend() {
  return request({
    url: '/eiip-ai/procurement/procurement-trend',
    method: 'get'
  })
}

/**
 * 物料齐套率（近 6 个月）
 * @returns {Promise}
 */
export function getMaterialKitRate() {
  return request({
    url: '/eiip-ai/procurement/material-kit-rate',
    method: 'get'
  })
}

/**
 * 供应商绩效分级（最新月份）
 * @returns {Promise}
 */
export function getSupplierGrade() {
  return request({
    url: '/eiip-ai/procurement/supplier-grade',
    method: 'get'
  })
}

/**
 * 供应商交期表现分布（最新月份）
 * @returns {Promise}
 */
export function getSupplierDelivery() {
  return request({
    url: '/eiip-ai/procurement/supplier-delivery',
    method: 'get'
  })
}

/**
 * 采购金额趋势（当年实际 + 年末预测）
 * @returns {Promise}
 */
export function getPurchaseAmountTrend() {
  return request({
    url: '/eiip-ai/procurement/purchase-amount-trend',
    method: 'get'
  })
}

/**
 * 高风险供应商清单
 * @returns {Promise}
 */
export function getHighRiskSuppliers() {
  return request({
    url: '/eiip-ai/procurement/high-risk-suppliers',
    method: 'get'
  })
}

/**
 * 供应商管控看板聚合数据（建议动作/分析结论/得分分布/高风险清单/较弱供应商）
 * @returns {Promise}
 */
export function getSupplierBoard() {
  return request({
    url: '/eiip-ai/supplier-board/board',
    method: 'get'
  })
}

/**
 * 合同履约智能体看板聚合数据（建议动作/分析结论/审阅风险明细/周期分布/订单预警/未到货订单）
 * @returns {Promise}
 */
export function getContractFulfillmentBoard() {
  return request({
    url: '/eiip-ai/contract-fulfillment/board',
    method: 'get'
  })
}

/**
 * 供需计划智能体看板聚合数据（建议动作/分析结论/缺货风险预警清单/建议补货明细/补货计划敞口）
 * @returns {Promise}
 */
export function getSupplyDemandBoard() {
  return request({
    url: '/eiip-ai/sd/board',
    method: 'get'
  })
}

/**
 * 供需计划智能体指标图表数据（6 张图，当前页面不渲染，接口预留）
 * @returns {Promise}
 */
export function getSupplyDemandMetrics() {
  return request({
    url: '/eiip-ai/sd/metrics',
    method: 'get'
  })
}
